import { render } from "./evaluation-page.vue?vue&type=template&id=5d74b771"
import script from "./evaluation-page.vue?vue&type=script&lang=js"
export * from "./evaluation-page.vue?vue&type=script&lang=js"

import "./evaluation-page.vue?vue&type=style&index=0&id=5d74b771&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__